/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateWorkspaceSchema
 */
export interface UpdateWorkspaceSchema {
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkspaceSchema
     */
    creditLimit: number;
}

/**
 * Check if a given object implements the UpdateWorkspaceSchema interface.
 */
export function instanceOfUpdateWorkspaceSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "creditLimit" in value;

    return isInstance;
}

export function UpdateWorkspaceSchemaFromJSON(json: any): UpdateWorkspaceSchema {
    return UpdateWorkspaceSchemaFromJSONTyped(json, false);
}

export function UpdateWorkspaceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWorkspaceSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'creditLimit': json['credit_limit'],
    };
}

export function UpdateWorkspaceSchemaToJSON(value?: UpdateWorkspaceSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'credit_limit': value.creditLimit,
    };
}

